import { Flex, Space } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { AppText } from "@/shared/Components";
import { getSafeLocalizedValue } from "@/shared/utils";
import { priceFormat } from "@/shared/utils/price-format";
import type { SubscriptionDTO } from "@/services/api/entities/payment";

type Props = {
  subscription: SubscriptionDTO;
};

export const HistoryItem = ({ subscription }: Props) => {
  const { t } = useTranslation();
  const isFuture = dayjs(subscription.activeStartDate).isAfter(dayjs());
  const isExpired = dayjs(subscription.activeEndDate).isBefore(dayjs());

  return (
    <Flex vertical gap={4}>
      <Flex justify="space-between">
        <AppText size="sm" weight="medium">
          {dayjs(subscription.activeStartDate).format("DD.MM.YYYY")} -{" "}
          {dayjs(subscription.activeEndDate).format("DD.MM.YYYY")}
        </AppText>
        <AppText
          size="xs"
          style={{
            color: isFuture
              ? "var(--text-base)"
              : isExpired
                ? "var(--text-secondary)"
                : "var(--text-positive)",
            marginLeft: "auto",
          }}
        >
          {isFuture
            ? t("settingsPage.general.subscription.future")
            : isExpired
              ? t("settingsPage.general.subscription.expired")
              : t("settingsPage.general.subscription.current")}
        </AppText>
      </Flex>
      <Flex justify="space-between">
        <AppText size="lg" weight="semibold">
          {getSafeLocalizedValue(
            subscription.localizedTariffName,
            subscription.localizedTariffName.ru,
          )}
        </AppText>
        <AppText size="lg" weight="semibold">
          {priceFormat({
            amount: subscription.amountPaid.toString(),
            currencyCode: subscription.currencyCode,
          })}
        </AppText>
      </Flex>
      <Flex vertical>
        {subscription.options.map((option) => (
          <Space key={option.localizedOptionName.ru} direction="vertical" style={{ rowGap: 0 }}>
            <AppText weight="semibold" key={option.localizedOptionName.ru}>
              {getSafeLocalizedValue(option.localizedOptionName, option.localizedOptionName.ru)}
            </AppText>
            <AppText key={option.localizedOptionName.ru}>
              {getSafeLocalizedValue(
                option.localizedOptionDescription,
                option.localizedOptionDescription.ru,
              )}
            </AppText>
          </Space>
        ))}
      </Flex>
    </Flex>
  );
};
